export default class KostoloigenyloClass {

    kostoloItemsSetEvents() {

        $(".kostololista-items .lista a").click(function (e) {
            e.preventDefault()
            $(this).toggleClass('selected')
            window.Kostoloigenylo.kostoloItemsChanger()

            var lastitem = $(this).attr('id').replace('kostoloselectitem-', '')
            $(".kostololista input[name='lastselected']").val(lastitem)

            var selecteditems = []
            $(".kostololista-items .lista a.selected").each(function (i, seli) {
                var kid = $(seli).attr('id').replace('kostoloselectitem-', '')
                selecteditems.push(kid)
            })
            console.log(selecteditems)
            if (selecteditems.length > 0) {
                $(".kostololista input[name='selectedkostolo']").val(selecteditems.join('|'))

                $.post('/index.php/termekkostolok/saveselected', { items: selecteditems.join('|') }, function () {
                    // $('.pms-main-win').removeClass('opened')
                    // setTimeout(function () {
                    //     $('.pms-overlay, .pms-main-win').remove();
                    //     $('body').removeClass('pms-showing');
                    // }, 300);

                    // window.Kostoloigenylo.updateSelectedKostolokLista()
                })
            } else {
                $(".kostololista input[name='selectedkostolo']").val('')
                $.post('/index.php/termekkostolok/saveselected', { items: '' }, function () {
                    // $('.pms-main-win').removeClass('opened')
                    // setTimeout(function () {
                    //     $('.pms-overlay, .pms-main-win').remove();
                    //     $('body').removeClass('pms-showing');
                    // }, 300);

                    // window.Kostoloigenylo.updateSelectedKostolokLista()
                })
            }


        })

        $('.kostololista .dialog-next-btn').click(function () {
            $('.pms-main-win').removeClass('opened')
            setTimeout(function () {
                $('.pms-overlay, .pms-main-win').remove();
                $('body').removeClass('pms-showing');
            }, 300);

            window.Kostoloigenylo.updateSelectedKostolokLista()
        })


        if (typeof kostolokMaxSelectNum != "undefined" && $('.maxselectableitem .maxitemnumber').length > 0) {
            $('.maxselectableitem .maxitemnumber').text(kostolokMaxSelectNum)
        }
    }

    kostoloItemsChanger() {
        var lastitem = $(".kostololista input[name='lastselected']").val()
        var maxitem = $(".kostololista-items .lista a.selected").length;
        if (typeof kostolokMaxSelectNum == "undefined") {
            kostolokMaxSelectNum = 2
        }
        $.each($(".kostololista-items .lista a"), function (i, item) {
            var itemid = $(this).attr('id').replace('kostoloselectitem-', '')
            if (maxitem > kostolokMaxSelectNum && $(this).hasClass('selected')) {
                $('#kostoloselectitem-' + lastitem).removeClass('selected')
            }
        })
    }

    kostoloSelectorOpen() {

        popupMessageSystem.showWin('', 'kostolo-igenyles-popup', 'opened', 300);
        $('.pms-message').empty();
        $('<div>').addClass('wait-datas').appendTo($('.pms-message'));
        setTimeout(function () {
            $('.pms-main-win.kostolo-igenyles-popup').addClass('opened')

            $.get('/index.php/webshop_hu/kosar/kostolovalaszto_dialog', { r: new Date().getTime() }, (res) => {
                if (res != '') {
                    $('.pms-message').html(res);

                    if ($('#kostolokMaxSelectNum').length > 0 && typeof kostolokMaxSelectNum == "undefined") {
                        kostolokMaxSelectNum = +$('#kostolokMaxSelectNum').val()
                    }
                    window.Kostoloigenylo.kostoloItemsSetEvents()
                }
            }, 'html');
        }, 300)

        return false;

    }

    updateSelectedKostolokLista() {
        $.get('/index.php/webshop/getselected_kostolok_lista', { r: new Date().getTime() }, (res) => {
            $('.selected-kostolo-list ul li').remove();
            if (res != '') {
                $('.selected-kostolo-list ul li').remove();
                $.each(res, function (i, item) {
                    $('.selected-kostolo-list ul').append('<li class="selected-kostolo-item">' + item.nev + '</li>');
                })
            }
        });
    }

}
